export enum IncidentDetailNavigationPaths {

  INCIDENT_DETAIL = 'incident-detail',
  ADD_SERVICE_CONTACT = 'add-service-contact'
}
